/// <reference path="login.ctrl.js" />
(function() {
    'use strict';

    angular
        .module('app')
        .controller('LoginController', LoginController);

    function LoginController($window,
        $cookies,
        $state,
        $location,
        $scope,
        $rootScope,
        $timeout,
        $localStorage,
        AuthenticationService,
        cfpLoadingBar) {

        // Using 'Controller As' syntax, so we assign this to the vm variable (for viewmodel).
        var vm = this;

        vm.userData = {
            userName: '',
            password: '',
            rememberMe: '',
        };

        $timeout.cancel($scope.mytimeout);

        // Bindable properties and functions are placed on vm.
        vm.loginUser = loginUser;
        vm.isWebApiCallFailed = false;
       
        (function initController() {
            // reset login status
            AuthenticationService.clearCredentials();
        })();
        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.setRootScope = function (currentUser) {
            $rootScope.globals = {
                currentUser: currentUser
            };
        }

        $scope.setLocal = function (currentUser) {
            $localStorage.currentUser = currentUser;
        }

        $scope.setBrandPermissions = function (data) {
            $rootScope.brandPermissions = JSON.parse(data.brands);
            $rootScope.userPermissions = JSON.parse(data.permissions);
        }

        vm.redirectURL = $rootScope.redirectURL

        function loginUser(isFormInvalid) {

            vm.isWebApiCallFailed = false;

            if (isFormInvalid) {
                return;
            }

            $scope.loginform.$setPristine();

            AuthenticationService
                .loginUser(vm.userData).then(function(data) {
                        vm.bearerToken = data.access_token;

                        AuthenticationService.setCredentials(data);

                        $rootScope.brandPermissions = JSON.parse(data.brands);
                        $rootScope.userPermissions = JSON.parse(data.permissions);
                        
                        if ($rootScope.redirectURL) {
                            $location.path($rootScope.redirectURL);
                        } else {
                            $state.go('home');
                        }

                        $rootScope.redirectURL = false;
                        $rootScope.sessionEnd = false; 
                    },
                    function(err) {

                        var enteredUserName = vm.userData.userName;

                        vm.userData = {
                            userName: '',
                            password: '',
                            rememberMe: '',
                        };

                        if (err.error === 'role_not_assigned') {
                            $rootScope.messageData = { code: 'RoleNotAssigned', title: 'Account Issue' };
                            $state.go('displayMessage');
                        } else if (err.error === 'confirm_email') {
                            $rootScope.messageData = { code: 'ConfirmEmail', title: 'Confirm Email' };
                            $state.go('displayMessage');
                        } else if (err.error === 'change_password_required') {
                            $rootScope.userName = enteredUserName;
                            $localStorage.changePasswordUserName = $rootScope.userName;
                            $state.go('changeUserPassword');
                        } else {
                            vm.isWebApiCallFailed = true;
                            $scope.loginform.$setPristine();
                            $scope.loginform.$setUntouched();
                        }
                    });
        };

        cfpLoadingBar.complete();
    }

})();
